// 30 min of no meaningful user activity ends the tab session (sessionEnd) and,
// across tabs, starts a new visit — matching the server's activity-segmentation
// session boundary.
export const IDLE_TIMEOUT_MS = 30 * 60 * 1000;

const INCREMENTAL_SNAPSHOT = 3;
// Mirrors the server's MEANINGFUL_INCREMENTAL_SOURCES (activity-segmenter.ts):
// MouseInteraction (2), Scroll (3), Input (5), TouchMove (6), Drag (12). NOTE:
// Drag is 12, NOT 9 — source 9 is CanvasMutation (auto canvas animation).
// Mutations/animation are not user activity, so they must not reset the idle timer.
const MEANINGFUL_SOURCES = new Set<number>([2, 3, 5, 6, 12]);

interface IncrementalEvent {
  type?: number;
  data?: { source?: number };
}

export function isMeaningfulEvent(event: unknown): boolean {
  if (typeof event !== 'object' || event === null) return false;
  const e = event as IncrementalEvent;
  return (
    e.type === INCREMENTAL_SNAPSHOT &&
    typeof e.data?.source === 'number' &&
    MEANINGFUL_SOURCES.has(e.data.source)
  );
}
